import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { INVOICES_GET_MANY } from 'api/query-keys.ts';
import type { InvoiceRes } from 'api/swagger';
import { PAGINATION_DEFAULT_LIMIT } from 'shared/constants/paginations';
import type { WithPagination } from 'shared/utils/pagination.ts';
import { preparePagination } from 'shared/utils/pagination.ts';
import type { IWithPagination } from 'types/api-query.ts';

interface IParams extends IWithPagination {
  orderId?: number;
  tripId?: number;
  whTaskId?: number;
}

export const useGetManyInvoicesByEntity = (params?: IParams) => {
  const { limit = PAGINATION_DEFAULT_LIMIT, page = 1, orderId, tripId, whTaskId } = params || {};

  const qs = new URLSearchParams({ limit: String(limit), page: String(page) });
  if (orderId) qs.set('filter[orderId]', String(orderId));
  if (tripId) qs.set('filter[tripId]', String(tripId));
  if (whTaskId) qs.set('filter[warehouseTaskId]', String(whTaskId));
  return useQuery<WithPagination<InvoiceRes[]>>({
    queryKey: [INVOICES_GET_MANY, page, limit, qs.toString()],
    queryFn: async () => {
      const { data, headers } = await http.get<InvoiceRes[]>(`/v1/invoices?${qs.toString()}`);
      const pagination = preparePagination(headers);

      return { data, pagination };
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 0,
    cacheTime: 0,
  });
};
